'use client';

import { useTranslations } from 'next-intl';
import { Maximize2 } from 'lucide-react';
import { SettingsItem } from '@/shared/ui/settings';

interface HiResSectionProps {
  isHires: boolean;
  onIsHiresChange: (value: boolean) => void;
}

/**
 * Hi-Res rendering toggle. Lives inside the "Advanced engine controls" group,
 * which is rendered ONLY for advanced-control holders (Builder Pass,
 * grandfathered Pro/Designer) — see `ScrollableRenderSettings`. By the time
 * this row is shown the user always has the capability, so there is no
 * lock/paywall path here. Mirrors the iOS Engine-section toggle row.
 */
export function HiResSection({ isHires, onIsHiresChange }: HiResSectionProps) {
  const t = useTranslations('render.settings.hires');

  return (
    <SettingsItem
      icon={Maximize2}
      title={t('title')}
      paddingClassName="px-4 py-3"
      toggle={{
        checked: isHires,
        onCheckedChange: onIsHiresChange,
      }}
      rowTogglesSwitch
    />
  );
}
